import { render } from "./vendorCode001.vue?vue&type=template&id=020bd468&scoped=true"
import script from "./vendorCode001.vue?vue&type=script&lang=js"
export * from "./vendorCode001.vue?vue&type=script&lang=js"

import "./vendorCode001.vue?vue&type=style&index=0&id=020bd468&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020bd468"]])

export default __exports__